import { useAuth0 } from 'shim/auth0-react'
import useSWR from 'swr'

import { GET_PROJECT_PLANS } from '../queries'
import { ProjectPlan } from './usePlan'
import { consoleFetcher } from 'common/fetchers/graphql'

export default function useProjectPlans() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0()
  const { data, error, mutate } = useSWR(
    isAuthenticated || process.env.NEXT_PUBLIC_BYPASS_AUTH_STATE
      ? [GET_PROJECT_PLANS, null, { tokenFn: getAccessTokenSilently }]
      : false,
    consoleFetcher,
    { shouldRetryOnError: false }
  )

  return {
    projectPlans: data ? (data.projectPlans.filter((plan: ProjectPlan) => plan.isActive) as ProjectPlan[]) : null,
    loading: typeof data === 'undefined' && !error,
    error: error || null,
    mutate,
  }
}
